import React, { useEffect, useRef, useState } from 'react';
import { getScrollParent } from '../../AIEmployees/useReveal';
import { Link } from 'react-router-dom';
import './LinearForTeams.css';

const CARDS = [
  {
    iconPath: (
      <>
        <circle cx="9" cy="7" r="4" />
        <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
        <circle cx="17" cy="7" r="4" />
        <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
      </>
    ),
    title: 'Workspace-level install',
    body:
      'One admin installs. The whole Linear workspace can delegate tasks. No per-user signup friction for your teammates.',
  },
  {
    iconPath: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 10h18" />
        <path d="M7 15h4" />
      </>
    ),
    title: 'Transparent billing',
    body: (
      <>
        Tasks consume credits from the installer&rsquo;s CellCog account. All
        workspace members share the same credit pool. See usage in the CellCog
        billing dashboard.{' '}
        <Link to="/pricing">View plans →</Link>
      </>
    ),
  },
  {
    iconPath: (
      <>
        <path d="M12 2L4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    title: 'Revoke anytime',
    body:
      'Disconnect from your CellCog profile settings, or directly from Linear\u2019s Application Settings. Active sessions are errored cleanly. Both sides stay in sync.',
  },
];

const LinearForTeams = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        });
      },
      { root: getScrollParent(ref.current), threshold: 0, rootMargin: '0px 0px 100% 0px' }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section className="linear-for-teams section" ref={ref}>
      <div className={`reveal ${visible ? 'is-visible' : ''}`}>
        <div className="linear-for-teams__header">
          <h2 className="section-title display-font">Built for teams, not just you.</h2>
          <p className="section-subtitle">
            Security, access, and billing designed for how Linear workspaces
            actually work.
          </p>
        </div>

        <div className="linear-for-teams__grid">
          {CARDS.map((c) => (
            <div key={c.title} className="teams-card">
              <div className="teams-card__icon" aria-hidden="true">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {c.iconPath}
                </svg>
              </div>
              <h3 className="teams-card__title display-font">{c.title}</h3>
              <p className="teams-card__body">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinearForTeams;
